module.exports = __webpack_public_path__ + "ecosystem-landing.0362520d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/ecosystem-landing.png
// module id = 2068
// module chunks = 0